import { Book } from '@eigtech/contacts-types'

export const isClaimBook = (book: Book) => book.metadata.type === 'claim'
